import { cn } from "@/lib/utils";
import { ShoppingBag, Percent, MessageSquareQuote, ArrowLeftRight, Grid3X3 } from "lucide-react";

const AD_TYPES = [
  {
    id: "showcase",
    name: "Showcase Produit",
    description: "Mise en valeur produit avec fond créatif",
    icon: ShoppingBag,
  },
  {
    id: "promo",
    name: "Promo / Soldes",
    description: "Créative urgente avec badge promo",
    icon: Percent,
  },
  {
    id: "testimonial",
    name: "Témoignage",
    description: "Style avis client avec citation",
    icon: MessageSquareQuote,
  },
  {
    id: "beforeafter",
    name: "Avant / Après",
    description: "Comparaison transformation",
    icon: ArrowLeftRight,
  },
  {
    id: "collection",
    name: "Collection",
    description: "Présentation multi-produits",
    icon: Grid3X3,
  },
];

interface AdTypeSelectorProps {
  selected: string;
  onSelect: (type: string) => void;
}

export function AdTypeSelector({ selected, onSelect }: AdTypeSelectorProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
      {AD_TYPES.map((type) => {
        const Icon = type.icon;
        return (
          <button
            key={type.id}
            onClick={() => onSelect(type.id)}
            className={cn(
              "p-4 rounded-xl border-2 transition-all duration-200 text-left",
              "hover:border-primary/50 hover:bg-primary/5",
              selected === type.id
                ? "border-primary bg-primary/10"
                : "border-border bg-card"
            )}
          >
            <Icon className={cn(
              "w-6 h-6 mb-2",
              selected === type.id ? "text-primary" : "text-muted-foreground"
            )} />
            <h4 className="font-medium text-sm">{type.name}</h4>
            <p className="text-xs text-muted-foreground mt-1">{type.description}</p>
          </button>
        );
      })}
    </div>
  );
}
